<template>
  <div>
    <header>
      <nav class="navbar navbar-expand-md navbar-dark fixed-top bg-dark">
        <div class="container-fluid">
          <a class="navbar-brand" href="#">Manufacturing Multi-Organs (MM)</a>
          <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>
          <!-- Sidebar Toggle-->
          <button class="btn btn-link btn-sm order-1 order-lg-0 me-4 me-lg-0" id="sidebarToggle" @click="sidebarToggle"><i class="fas fa-bars"></i></button>
          <div class="collapse navbar-collapse" id="navbarCollapse">
            <ul class="navbar-nav me-auto mb-2 mb-auto">
              <li class="nav-item">
                <a class="nav-link" aria-current="page" @click="routePush('/')">Home</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" @click="routePush('/organs')">Organs</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" @click="routePush('/models')">Models</a>
              </li>
              <li class="nav-item">
                <a class="nav-link active" @click="routePush('/materials')">Materials</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="https://gulab.info/about/">About</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" @click="routePush('/visitors')">Visitors</a>
              </li>
            </ul>
            <form class="d-flex">
              <input class="form-control me-2" type="search" placeholder="Search" aria-label="Search">
              <button class="btn btn-outline-light" onmouseover="this.style.backgroundColor='black';" onmouseout="this.style.backgroundColor='';"
                      type="submit" style="color:white">Search</button>
            </form>
          </div>
        </div>
      </nav>
    </header>

    <div class="sb-nav-fixed">
      <div id="layoutSidenav">
        <div id="layoutSidenav_nav" style="z-index: 3">
          <nav class="sb-sidenav accordion sb-sidenav-dark" id="sidenavAccordion">
            <div class="sb-sidenav-menu">
              <div class="nav">
                <div class="sb-sidenav-menu-heading">Statistics</div>
                <a class="nav-link" @click="routePush('/materials')">
                  <div class="sb-nav-link-icon"><i class="fas fa-chart-pie"></i></div>
                  Components
                </a>
                <a class="nav-link collapsed" @click="routePush('/patents')" data-bs-toggle="collapse" data-bs-target="#collapseLayouts" aria-expanded="false" aria-controls="collapseLayouts">
                  <div class="sb-nav-link-icon"><i class="fas fa-chart-area"></i></div>
                  Patents
                </a>
                <a class="nav-link active collapsed" @click="routePush('/patentsComponents')" data-bs-toggle="collapse" data-bs-target="#collapseLayouts" aria-expanded="false" aria-controls="collapseLayouts">
                  <div class="sb-nav-link-icon"><i class="fas fa-chart-bar"></i></div>
                  Pantent Components
                </a>
              </div>
            </div>

          </nav>
        </div>
        <div id="layoutSidenav_content" style="margin-top:3%">
          <main>
            <div class="container-fluid px-4">
              <div class="row" style="margin-top: 1.5rem">
                <div class="col-lg-6">
                  <div class="card mb-4">
                    <div class="card-header">
                      <i class="fas fa-chart-bar me-1"></i>
                      Statistic of Biomaterials
                    </div>
                    <div class="card-body"><div id="biomaterials" style="width:100%;height:400px"></div></div>
                  </div>
                </div>
                <div class="col-xl-6">
                  <div class="card mb-4">
                    <div class="card-header">
                      <i class="fas fa-chart-bar me-1"></i>
                      Statistic of Cells
                    </div>
                    <div class="card-body"><div id="cells" style="width:100%;height:400px"></div></div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-12">
                  <div class="card mb-4">
                    <div class="card-header">
                      <i class="fas fa-chart-bar me-1"></i>
                      Statistic of Organs
                    </div>
                    <div class="card-body"><div id="organs" style="width:100%;height:400px"></div></div>
                  </div>
                </div>
              </div>
            </div>
          </main>
          <footer class="py-4 bg-light mt-auto">
            <div class="container-fluid px-4">
              <div class="d-flex align-items-center justify-content-between small">
                <div class="text-muted">Copyright &copy; Group of Bioinspired Engineering 2023</div>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import '../../assets/js/jquery-3.6.0.min.js'
// import '../../assets/js/bootstrap.bundle.min.js'
import * as echarts from "echarts";

import {
  getPatentBiomaterial,
  getPatentCell,
  getPatentOrgan
} from "@/request/materials";
export default {
  name: 'index',
  data(){
    return{}
  },
  mounted () {
    this.getPatentBiomaterial();
    this.getPatentCell();
    this.getPatentOrgan();
  },
  methods:{
    getPatentBiomaterial(){
      getPatentBiomaterial('').then(res => {
        const data= res.filter((item,inx)=>{
          item.value= item.count;
            return item;
        });

        data.forEach((item,index)=>{
          item.itemStyle={
            barBorderRadius: [0, 10, 10, 0],
            // color: this.color[index%this.color.length],
            color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
              { offset: 0, color: '#0663dbb3' },
              { offset: 0.2, color: '#0663dbb3' },
              { offset: 1, color: '#0663db' }
            ])
          };
          item.label= {
            show: true,
            color: '#8f949f',
            position: 'right',
            valueAnimation: true
          }
        });
        let xAxisData = data.map((item)=>{ return item.name});
        let seriesData=  data.splice(0,100).reverse();
        let ctx = echarts.init(document.getElementById('biomaterials'));
        let option  = {
          tooltip: {},
          grid : {
            left: 0,
            // right : 0,
            bottom : 0,
            top : 10,
            containLabel : true
          },
          dataZoom:[
            {
              type: 'slider',
              maxValueSpan:9,//显示数据的条数(默认显示10个)
              show: true,
              width:  '5',
              height:  '100%',
              yAxisIndex: [0],
              // left: '93%', //滑动条位置
              start:100,//默认为0
              end: 100-9/seriesData.length*100,//默认为100
              orient:"vertical",
              filterMode: 'empty',
              zoomLock:true,
              fillerColor: "#2f96f6", // 滚动条颜色
              borderColor: "rgba(17, 100, 210, 0.12)",
              backgroundColor: '#c1dcff',//两边未选中的滑动条区域的颜色
              handleSize:0, // 两边手柄尺寸
              showDataShadow: false,//是否显示数据阴影 默认auto
              showDetail: false, // 拖拽时是否展示滚动条两侧的文字
              top:'1%',
              right:'5',
            },
            {
              type: 'inside', //内置滑动，随鼠标滚轮展示
              yAxisIndex: [0],
              start: 100,//初始化时，滑动条宽度开始标度
              end: 100-9/seriesData.length*100,//默认为100
              zoomOnMouseWheel:false, //如何触发缩放。可选值为：true：表示不按任何功能键，鼠标滚轮能触发缩放。false：表示鼠标滚轮不能触发缩放。'shift'：表示按住 shift 和鼠标滚轮能触发缩放。'ctrl'：表示按住 ctrl 和鼠标滚轮能触发缩放。'alt'：表示按住 alt 和鼠标滚轮能触发缩放。。
              moveOnMouseMove:true,
              moveOnMouseWheel:true,//鼠标滚轮实现移动
            }
          ],
          xAxis: [
            {
              name: '',
              type: 'value',
              nameTextStyle:{
                color:'#262626'
              },
              axisTick: {show: false},
              axisLine: {
                show: false,
                lineStyle:{
                  color:'#ededed'
                }
              },
              splitLine:{
                show: true,
                lineStyle:{
                  color:'#ededed'
                }},
              axisLabel:{
                color:'#6F6F6F',
              },
            }
          ],
          yAxis: [
            {
              type: 'category',
              axisTick: {show: false},
              axisLine: {
                show: true,
                lineStyle:{
                  color:'#979797'
                }
              },
              axisLabel:{
                color:'#6F6F6F',
                interval: 0,
                // rotate: 45,
                formatter: function(params) {
                  var newParamsName = "";
                  var paramsNameNumber = params.length;
                  var provideNumber = 20;
                  if (paramsNameNumber > provideNumber) {
                    newParamsName= params.substr(0,provideNumber)+'...';
                  } else {
                    newParamsName = params;
                  }
                  return newParamsName;
                }
              },
              data:  xAxisData.splice(0,100).reverse()
            }
          ],
          series: [
            {
              type: 'bar',
              barGap: 0,  //两个柱状之间的间隙
              barWidth :25, //柱形的宽度
              data: seriesData
            }
          ]
        };
        ctx.setOption(option);
      });
    },

    getPatentCell(){
      getPatentCell('').then(res => {
        const data= res.filter((item,inx)=>{
          item.value= item.count;
          return item;
        });
        data.forEach((item,index)=>{
          item.itemStyle={
            barBorderRadius: [0, 10, 10, 0],
            // color: this.color[index%this.color.length],
            color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
              { offset: 0, color: '#788de0b3' },
              { offset: 0.2, color: '#788de0b3' },
              { offset: 1, color: '#788de0' }
            ])
          };
          item.label= {
            show: true,
            color: '#8f949f',
            position: 'right',
            valueAnimation: true
          }
        });
        let xAxisData = data.map((item)=>{ return item.name});
        let seriesData= data.splice(0,100).reverse();
        let ctx = echarts.init(document.getElementById('cells'));
        let option  = {
          tooltip: {},
          grid : {
            left: 0,
            // right : 0,
            bottom : 0,
            top : 10,
            containLabel : true
          },
          dataZoom:[
            {
              type: 'slider',
              maxValueSpan:9,//显示数据的条数(默认显示10个)
              show: true,
              width:  '5',
              height:  '100%',
              yAxisIndex: [0],
              // left: '93%', //滑动条位置
              start:100,//默认为0
              end: 100-9/seriesData.length*100,//默认为100
              orient:"vertical",
              filterMode: 'empty',
              zoomLock:true,
              fillerColor: "#2f96f6", // 滚动条颜色
              borderColor: "rgba(17, 100, 210, 0.12)",
              backgroundColor: '#c1dcff',//两边未选中的滑动条区域的颜色
              handleSize:0, // 两边手柄尺寸
              showDataShadow: false,//是否显示数据阴影 默认auto
              showDetail: false, // 拖拽时是否展示滚动条两侧的文字
              top:'1%',
              right:'5',
            },
            {
              type: 'inside', //内置滑动，随鼠标滚轮展示
              yAxisIndex: [0],
              start: 100,//初始化时，滑动条宽度开始标度
              end: 100-9/seriesData.length*100,//默认为100
              zoomOnMouseWheel:false, //如何触发缩放。可选值为：true：表示不按任何功能键，鼠标滚轮能触发缩放。false：表示鼠标滚轮不能触发缩放。'shift'：表示按住 shift 和鼠标滚轮能触发缩放。'ctrl'：表示按住 ctrl 和鼠标滚轮能触发缩放。'alt'：表示按住 alt 和鼠标滚轮能触发缩放。。
              moveOnMouseMove:true,
              moveOnMouseWheel:true,//鼠标滚轮实现移动
            }
          ],
          xAxis: [
            {
              name: '',
              type: 'value',
              nameTextStyle:{
                color:'#262626'
              },
              axisTick: {show: false},
              axisLine: {
                show: false,
                lineStyle:{
                  color:'#ededed'
                }
              },
              splitLine:{
                show: true,
                lineStyle:{
                  color:'#ededed'
                }},
              axisLabel:{
                color:'#6F6F6F',
              },
            }
          ],
          yAxis: [
            {
              type: 'category',
              axisTick: {show: false},
              axisLine: {
                show: true,
                lineStyle:{
                  color:'#979797'
                }
              },
              axisLabel:{
                color:'#6F6F6F',
                interval: 0,
                // rotate: 45,
                formatter: function(params) {
                  var newParamsName = "";
                  var paramsNameNumber = params.length;
                  var provideNumber = 20;
                  if (paramsNameNumber > provideNumber) {
                    newParamsName= params.substr(0,provideNumber)+'...';
                  } else {
                    newParamsName = params;
                  }
                  return newParamsName;
                }
              },
              data: xAxisData.splice(0,100).reverse()
            }
          ],
          series: [
            {
              type: 'bar',
              barGap: 0,  //两个柱状之间的间隙
              barWidth :25, //柱形的宽度
              data: seriesData
            }
          ]
        };
        ctx.setOption(option);
      });

    },

    getPatentOrgan(){
      getPatentOrgan('').then(res => {
        const data= res.filter((item,inx)=>{
          item.value= item.count;
          return item;
        });
        data.forEach((item,index)=>{
          item.itemStyle={
            barBorderRadius: [0, 10, 10, 0],
            // color: this.color[index%this.color.length],
            color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
              { offset: 0, color: '#51d8e7' },
              { offset: 0.2, color: '#2cbccc' },
              { offset: 1, color: '#16a5b4' }
            ])
          };
          item.label= {
            show: true,
            color: '#8f949f',
            position: 'right',
            valueAnimation: true
          }
        });
        let xAxisData = data.map((item)=>{ return item.name});
        let seriesData=  data.splice(0,100).reverse();
        let ctx = echarts.init(document.getElementById('organs'));
        let option  = {
          tooltip: {},
          grid : {
            left: 0,
            // right : 0,
            bottom : 0,
            top : 10,
            containLabel : true
          },
          dataZoom:[
            {
              type: 'slider',
              maxValueSpan:9,//显示数据的条数(默认显示10个)
              show: true,
              width:  '5',
              height:  '100%',
              yAxisIndex: [0],
              // left: '93%', //滑动条位置
              start:100,//默认为0
              end: 100-9/seriesData.length*100,//默认为100
              orient:"vertical",
              filterMode: 'empty',
              zoomLock:true,
              fillerColor: "#2f96f6", // 滚动条颜色
              borderColor: "rgba(17, 100, 210, 0.12)",
              backgroundColor: '#c1dcff',//两边未选中的滑动条区域的颜色
              handleSize:0, // 两边手柄尺寸
              showDataShadow: false,//是否显示数据阴影 默认auto
              showDetail: false, // 拖拽时是否展示滚动条两侧的文字
              top:'1%',
              right:'5',
            },
            {
              type: 'inside', //内置滑动，随鼠标滚轮展示
              yAxisIndex: [0],
              start: 100,//初始化时，滑动条宽度开始标度
              end: 100-9/seriesData.length*100,//默认为100
              zoomOnMouseWheel:false, //如何触发缩放。可选值为：true：表示不按任何功能键，鼠标滚轮能触发缩放。false：表示鼠标滚轮不能触发缩放。'shift'：表示按住 shift 和鼠标滚轮能触发缩放。'ctrl'：表示按住 ctrl 和鼠标滚轮能触发缩放。'alt'：表示按住 alt 和鼠标滚轮能触发缩放。。
              moveOnMouseMove:true,
              moveOnMouseWheel:true,//鼠标滚轮实现移动
            }
          ],
          xAxis: [
            {
              name: '',
              type: 'value',
              nameTextStyle:{
                color:'#262626'
              },
              axisTick: {show: false},
              axisLine: {
                show: false,
                lineStyle:{
                  color:'#ededed'
                }
              },
              splitLine:{
                show: true,
                lineStyle:{
                  color:'#ededed'
                }},
              axisLabel:{
                color:'#6F6F6F',
              },
            }
          ],
          yAxis: [
            {
              type: 'category',
              axisTick: {show: false},
              axisLine: {
                show: true,
                lineStyle:{
                  color:'#979797'
                }
              },
              axisLabel:{
                color:'#6F6F6F',
                interval: 0,
                // rotate: 45,
                formatter: function(params) {
                  var newParamsName = "";
                  var paramsNameNumber = params.length;
                  var provideNumber = 20;
                  if (paramsNameNumber > provideNumber) {
                    newParamsName= params.substr(0,provideNumber)+'...';
                  } else {
                    newParamsName = params;
                  }
                  return newParamsName;
                }
              },
              data:  xAxisData.splice(0,100).reverse()
            }
          ],
          series: [
            {
              type: 'bar',
              barGap: 0,  //两个柱状之间的间隙
              barWidth :25, //柱形的宽度
              data: seriesData
            }
          ]
        };
        ctx.setOption(option);
      });
    },

    sidebarToggle(){
      document.body.classList.toggle('sb-sidenav-toggled');
      localStorage.setItem('sb|sidebar-toggle', document.body.classList.contains('sb-sidenav-toggled'));
    },

    routePush(path){
      this.$router.push({ path:path })
    },
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/css/styles.css";
@import "../../assets/css/bootstrap.min.css";

.bd-placeholder-img {
  font-size: 1.125rem;
  text-anchor: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
}

@media (min-width: 768px) {
  .bd-placeholder-img-lg {
    font-size: 3.5rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/materials/pantentComponents.vue